import React from 'react';
import './Loader.css';

function Loader({ logo, text, showLogo = false, isLoading = true }) {
  return (
    <div className={`loader-container ${!isLoading ? 'fade-out' : ''}`}>
      <div className="loader-content">
        {showLogo && logo && (
          <div className="loader-logo">
            <img src={logo} alt="Logo" className="loader-logo-img" />
          </div>
        )}
        <div className="loader"></div>
        {text && (
          <div className="loader-text">
            {text}
          </div>
        )}
      </div>
    </div>
  );
}

export default Loader; 